module.exports = __webpack_public_path__ + "img/logo-ecartapi-white.bdce1a5c.svg";